export enum Experiment {
  EnableCSSOptimization = 'specs.membersAboutOOI.EnableCSSOptimization',
  EnableAccessibleRCE = 'specs.membersAbout.EnableAccessibleRCE',
  UseNewPostsCoverDefaults = 'specs.membersAbout.UseNewPostsCoverDefaults',
  EnableAboutContainerStyles = 'specs.membersAbout.EnableAboutContainerStyles',
  UseMigratedEditor3StylesParams = 'specs.membersAbout.UseMigratedEditor3Styles',
  EnableHtmlTagSettings = 'specs.membersAbout.EnableHtmlTagSettings',
}
